export class BigcommerceGraphQLClient {
  constructor(private readonly storefrontToken: string) {}

  async query({
    query,
    variables,
  }: {
    query: string;
    variables?: any;
  }): Promise<any> {
    const response = await fetch("/graphql", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.storefrontToken}`,
      },
      body: JSON.stringify({ query, variables }),
    });

    if (!response.ok) {
      console.error("GraphQL response not ok", response);
      throw new Error("Failed to make BigCommerce GraphQL request");
    }

    return await response.json();
  }
}
